import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { fadeIn } from '../../constants/keyframes/fades';
import zIndex from '../../constants/zIndex';

const StyledLoader = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: #fff;
	opacity: 0;
	animation: ${fadeIn} 400ms linear forwards;
	animation-delay: 600ms;
	z-index: ${zIndex.loading};
`;

interface Props {}

const MainLoader: FC<Props> = () => {
	const loading = useSelector((state: { pageReducer: { loading: boolean } }) => state.pageReducer.loading);

	if (!loading) return null;

	return <StyledLoader />;
};

export default MainLoader;
